export const registrationConstante = Object.freeze({
  REGISTRATION_ACTOR_APPRENTICE: 1,
  REGISTRATION_ACTOR_COMPANY: 2,
  REGISTRATION_ACTOR_CFA: 3,
  REGISTRATION_ACTOR_UFA: 4,

  REGISTRATION_SALARY_TAB_CODE: "tab-salary",
  REGISTRATION_QUOTE_TAB_CODE: "tab-quote",

  REGISTRATION_STATUS_UPCOMING: 1,
  REGISTRATION_STATUS_IN_PROGRESS: 2,
  REGISTRATION_STATUS_FINALIZED: 3,
  REGISTRATION_STATUS_RUPTURE: 4,
  REGISTRATION_STATUS_CANCELLED: 5,

  REGISTRATION_STEP_STATUS_NONE: 0,
  REGISTRATION_STEP_STATUS_PENDING: 1,
  REGISTRATION_STEP_STATUS_VALIDATED: 2,
  REGISTRATION_STEP_STATUS_REFUSED: 3,
  REGISTRATION_STEP_STATUS_CANCELLED: 4,

  CONTRACT_APPRENTICESHIP_HORS_APPRENTISSAGE: 0,
  CONTRACT_APPRENTICESHIP_APPRENTISSAGE: 1,
  CONTRACT_PRO_CFA: 2,
  CONTRACT_PROFESSIONAL_TRAINING: 3,

  contractTypeTargetAudiencesLabels: {
    1: "registration.contractType.apprentice",
    2: "registration.contractType.pro",
  },

  REGISTRATION_STATUS: {
    1: "init",
    2: "to_send_to_training_center",
    3: "sent_to_training_center",
    4: "validated_training_center",
    5: "signed",
    6: "error",
    7: "archived",
  },
});
